// @ts-nocheck
(function () {
  // Guard against a second copy of this script adding a second set of handlers (it was loaded twice on
  // product pages until 2026-10-15, so every colour switch sent Klaviyo "Viewed Product" twice).
  if (window.__klaviyoReviewsRefreshInit) return;
  window.__klaviyoReviewsRefreshInit = true;

  var WIDGET_SELECTORS = [
    '#klaviyo-reviews-all',
    '#fulfilled-reviews-all',
    '#klaviyo-reviews-list',
    '#fulfilled-reviews-list',
    '#klaviyo-reviews-summary',
    '#fulfilled-reviews-summary',
    '#klaviyo-featured-reviews-carousel',
    '#fulfilled-featured-reviews-carousel',
    '.klaviyo-star-rating-widget',
    '.fulfilled-star-rating-widget',
  ].join(', ');

  // A combined-listing colour switch loads a different product (variant:update with mainMorphed).
  // assets/variant-picker.js has already copied the new product's data into window.__klProduct.
  // Sends what Klaviyo's app sends on a product page load: "Viewed Product", plus trackViewedItem, which feeds
  // the profile's recently viewed items (browse-abandonment emails).
  document.addEventListener('variant:update', function (e) {
    if (!e.detail?.data?.mainMorphed) return;

    var klProduct = window.__klProduct;
    if (klProduct) {
      var learnq = window._learnq = window._learnq || [];
      learnq.push(['track', 'Viewed Product', klProduct]);
      learnq.push(['trackViewedItem', {
        Title: klProduct.Name,
        ItemId: klProduct.ProductID,
        Categories: klProduct.Categories,
        ImageUrl: klProduct.ImageURL,
        Url: klProduct.URL,
        Metadata: {
          Brand: klProduct.Brand,
          Price: klProduct.Price,
          CompareAtPrice: klProduct.CompareAtPrice
        }
      }]);
    }
  });

  // The reviews section sits outside the product section and is refreshed in the background after a switch;
  // product:sections-refreshed fires once it carries the new product's id, so redraw the widgets then.
  document.addEventListener('product:sections-refreshed', function () {
    requestAnimationFrame(function () {
      document.querySelectorAll(WIDGET_SELECTORS).forEach(function (el) {
        el.replaceWith(el.cloneNode(false));
      });

      var klObj = window.klReviewsObject;
      if (klObj) klObj.renderWidgets();
    });
  });
})();
